// Configurações do site que mudam com o tempo ficam aqui, num lugar só.

export const WHATSAPP_NUMERO = '5545999598011';
export const WHATSAPP_EXIBICAO = '(45) 99959-8011';

export function linkWhatsApp(mensagem) {
    const base = `https://wa.me/${WHATSAPP_NUMERO}`;
    return mensagem ? `${base}?text=${encodeURIComponent(mensagem)}` : base;
}

export const INSTAGRAM_URL = 'https://www.instagram.com/c1010sistemas/';
export const LINKEDIN_URL = 'https://www.linkedin.com/company/c1010-sistemas/';

export const TORQUE_DEMO_URL = 'https://torque.c1010.com.br';

// CTA do card do Gerenciador de Transportes.
// Quando a demonstração existir, troque para:
//   texto: 'Testar demonstração grátis',
//   url: 'https://<endereço-da-demo>',
export const CTA_TRANSPORTES = {
    texto: 'Fale com a gente',
    url: linkWhatsApp('Olá! Quero conhecer o Gerenciador de Transportes.'),
};

// CTA da seção "Projetos sob demanda".
export const CTA_SOB_DEMANDA = {
    texto: 'Contar meu projeto',
    url: linkWhatsApp('Olá! Tenho um projeto sob demanda para conversar.'),
};

// Chave de acesso do Web3Forms (https://web3forms.com).
// É uma chave pública: pode ficar no código do front-end.
export const WEB3FORMS_ACCESS_KEY = '87c69347-b976-4108-b4af-03a6ed0f7049';
